import WebService from "./WebService";
import { LedgerStatement, OutstandingBalances } from "../Models/Models";

export interface LedgerQuery {
  page?: number;
  limit?: number;
  fromDate?: string;
  toDate?: string;
  transactionTypes?: string;
}

function queryString(params: LedgerQuery): string {
  const parts: string[] = [
    `page_number=${params.page ?? 1}`,
    `limit=${params.limit ?? 20}`,
  ];
  if (params.fromDate) parts.push(`from_date=${params.fromDate}`);
  if (params.toDate) parts.push(`to_date=${params.toDate}`);
  if (params.transactionTypes) parts.push(`transaction_types=${params.transactionTypes}`);
  return parts.join("&");
}

export function fetchClientLedger(userId: number, params: LedgerQuery = {}) {
  return WebService.getAPI<{ data: LedgerStatement }>({
    action: `/v1/door-management/accounts/${userId}/ledger?${queryString(params)}`,
  });
}

export function fetchVendorLedger(vendorId: number, params: LedgerQuery = {}) {
  return WebService.getAPI<{ data: LedgerStatement }>({
    action: `/v1/door-management/vendors/${vendorId}/ledger?${queryString(params)}`,
  });
}

export function fetchOutstandingBalances() {
  return WebService.getAPI<{ data: OutstandingBalances }>({
    action: `/v1/door-management/accounts/outstanding`,
  });
}

export function recordVendorPayment(
  vendorId: number,
  body: {
    amount: number;
    payment_date?: string;
    payment_method?: string;
    reference_number?: string;
    notes?: string;
    purchase_order_id?: number;
  }
) {
  return WebService.postAPI<{ data: Record<string, unknown> }>({
    action: `/v1/door-management/vendors/${vendorId}/payments`,
    body,
  });
}
